import { render, staticRenderFns } from "./AccessoriesItem.vue?vue&type=template&id=99e479c6&scoped=true"
import script from "./AccessoriesItem.vue?vue&type=script&lang=js"
export * from "./AccessoriesItem.vue?vue&type=script&lang=js"
import style0 from "./AccessoriesItem.vue?vue&type=style&index=0&id=99e479c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e479c6",
  null
  
)

export default component.exports